import { render } from "./com-account-level-form.vue?vue&type=template&id=4934ddd8"
import script from "./com-account-level-form.vue?vue&type=script&lang=js"
export * from "./com-account-level-form.vue?vue&type=script&lang=js"
script.render = render

export default script